export const formStyles = (css, attributes) => ({
    separator: { wrapper: css.separator },
    ...attributes.reduce((acc, key) => {
        acc[key] = { wrapper: css.field };
        return acc;
    }, {})
});
